import * as types from '../actions/types';

const initialState = {
  structure: [],
  isLoading: false,
};

export default function structure(state = initialState, action) {
  switch (action.type) {
    case types.STRUCTURE_FETCH_STARTED:
      return {
        ...state,
        isLoading: true,
      };
    case types.STRUCTURE_FETCH_COMPLETED:
      return {
        ...state,
        structure: action.structure,
        isLoading: false,
      };
    default:
      return state;
  }
}
